export default function CheckCircle() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      fill="none"
      viewBox="0 0 100 100"
    >
      <path
        fill="#7AC959"
        d="M50 6.25C25.84 6.25 6.25 25.84 6.25 50S25.84 93.75 50 93.75 93.75 74.16 93.75 50 74.16 6.25 50 6.25zm18.897 29.463L48.33 64.228a3.107 3.107 0 01-5.049 0L31.104 47.355a.784.784 0 01.634-1.24h4.58a3.11 3.11 0 012.53 1.298L45.8 57.06l15.351-21.288a3.123 3.123 0 012.53-1.3h4.58a.784.784 0 01.635 1.24z"
      ></path>
    </svg>
  );
}
